import { useTranslation } from 'react-i18next';
import { Translate } from '@/common/components/Translate/Translate';
import { IBenefitOptin } from '@/common/integrations/menhir/employee/benefits/benefits.types';
import { DateUtils } from '@/common/utils/date';
import { MoneyUtils } from '@coverflex-tech/hypernova-utils';

export function useGetOptInCardContent(optIn: IBenefitOptin) {
  const { t } = useTranslation();

  const allocatedTitle = t('dashboard.benefits_optin.card.title_hold', {
    amount: MoneyUtils.moneyToString(
      optIn.allocatedAmount ?? MoneyUtils.defaultMoney
    ),
  });

  if (!optIn.editable) {
    return {
      title: allocatedTitle,
      description: t('dashboard.benefits_optin.card.description_lock'),
    };
  }

  if (optIn.allocatedAmount) {
    return {
      title: allocatedTitle,
      description: (
        <Translate
          i18nKey="dashboard.benefits_optin.card.description_hold"
          values={{
            date: DateUtils.formatDate(optIn.dueDate),
          }}
        />
      ),
    };
  }

  return {
    title: t('dashboard.benefits_optin.card.title', {
      amount: MoneyUtils.moneyToString(optIn.amount),
    }),
    description: (
      <Translate
        i18nKey="dashboard.benefits_optin.card.description"
        values={{
          date: DateUtils.formatDate(optIn.dueDate),
        }}
      />
    ),
  };
}
